import type { ServicePageData } from './types';

const windowPrivacyFilm: ServicePageData = {
  slug: 'window-privacy-film',
  eyebrow: 'Signage',
  title: 'Add privacy without losing',
  titleAccent: 'natural light.',
  intro:
    'Our etched vinyl gives a sandblasted or frosted look to your glass windows or doors, providing privacy day and night, whilst still allowing natural light through. The etched finish will make your glass translucent to the point where only basic shapes can be seen, hiding valuables, clutter or activity.',
  heroImages: [
    '/home/window-privacy-film/bamboo-etch.jpg',
    '/home/window-privacy-film/black-heart-etch.jpg',
    '/home/window-privacy-film/etch-bts.jpg',
    '/home/window-privacy-film/fs-etch.jpg',
    '/home/window-privacy-film/hagley-etch.jpg',
    '/home/window-privacy-film/hagley-etch2.jpg',
    '/home/window-privacy-film/kearns-etch-bts.jpg',
    '/home/window-privacy-film/kemp-etch.jpg',
    '/home/window-privacy-film/melting-pot-etch.jpg',
    '/home/window-privacy-film/melting-pot-etch2.jpg',
    '/home/window-privacy-film/petal-bar-etch.jpg',
    '/home/window-privacy-film/salon4-etch.jpg',
    '/home/window-privacy-film/scouts-etch.jpg',
    '/home/window-privacy-film/vets-etch.jpg',
    '/home/services/window-film.jpg',
    '/home/window-privacy-film/fs-etch.jpg',
    '/home/window-privacy-film/kemp-etch.jpg',
    '/home/window-privacy-film/melting-pot-etch.jpg',
    '/home/window-privacy-film/petal-bar-etch.jpg',
    '/home/window-privacy-film/salon4-etch.jpg',
    '/home/window-privacy-film/vets-etch.jpg',
  ],

  useCases: [
    { title: 'Homes', text: 'Replaces net curtains and is perfect for the bottom half of your windows.' },
    { title: 'Offices and meeting rooms', text: 'Ideal for glass room dividers to add privacy.' },
    { title: 'Bathrooms and kitchens', text: 'Suitable for application as it is resistant to condensation.' },
    { title: 'Shopfronts and studios', text: 'An excellent way to keep your branding on show.' },
    { title: 'Glass manifestation', text: 'Required by law for commercial spaces to make glass visible.' },
  ],

  optionsHeading: 'Choose your film',
  optionsIntro: 'Window privacy film is available in a range of styles to suit your privacy and branding requirements.',
  options: [
    {
      id: 'full-coverage',
      title: 'Full coverage',
      lead: 'For maximum privacy day and night.',
      body: 'The etched finish will make your glass translucent to the point where only basic shapes can be seen, hiding valuables, clutter or activity.',
      image: '/home/window-privacy-film/fs-etch.jpg',
      specs: [
        { label: 'Light', value: 'Allows up to 80% of natural light through.' },
        { label: 'Format', value: 'Supplied on the roll or cut to size.' },
        { label: 'Surface', value: 'Suitable for any smooth glass surface.' },
      ],
    },
    {
      id: 'cut-out',
      title: 'Cut out',
      lead: 'Add your branding or message.',
      body: 'Decorative window film comes in 16 stock designs ready to apply, or we can cut out custom shapes.',
      image: '/home/window-privacy-film/black-heart-etch.jpg',
      specs: [
        { label: 'Design', value: '16 stock decorative designs available.' },
        { label: 'Customisation', value: 'Cut to size with custom cut-outs.' },
        { label: 'Surface', value: 'Suitable for any smooth glass surface.' },
      ],
    },
    {
      id: 'layered-decals',
      title: 'Layered decals',
      lead: 'Branded with maximum privacy.',
      body: 'By layering a dark colour vinyl behind the etch, you\'ll see it on the other side, making your window look like an illuminated lightbox when the lights are on inside.',
      image: '/home/window-privacy-film/petal-bar-etch.jpg',
      specs: [
        { label: 'Effect', value: 'Lightbox effect when lit inside.' },
        { label: 'Light', value: 'Standard etch allows up to 80% of natural light through.' },
      ],
    },
    {
      id: 'coloured-and-tinted',
      title: 'Coloured and tinted',
      lead: 'Lighter and heavier opacities available.',
      body: 'In addition to our standard etched glass window film, we offer a range of opacities and colours to suit your space.',
      image: '/home/window-privacy-film/bamboo-etch.jpg',
      specs: [
        { label: 'Opacity', value: 'Lighter and heavier opacities available.' },
        { label: 'Colours', value: 'Range of colours available.' },
      ],
    },
  ],

  gallery: [
    '/home/window-privacy-film/bamboo-etch.jpg',
    '/home/window-privacy-film/fs-etch.jpg',
    '/home/window-privacy-film/kemp-etch.jpg',
    '/home/window-privacy-film/melting-pot-etch.jpg',
    '/home/window-privacy-film/salon4-etch.jpg',
    '/home/window-privacy-film/vets-etch.jpg',
    '/home/window-privacy-film/hagley-etch.jpg',
    '/home/window-privacy-film/black-heart-etch.jpg',
    '/home/window-privacy-film/petal-bar-etch.jpg',
  ],

  info: [
    {
      title: 'Professional installation',
      text: 'Our professional install team has years of experience applying flawless window films bubble-free throughout the Midlands.',
      bullets: [
        'Fully insured',
        'Bubble-free application',
        'Access equipment provided',
      ],
    },
    {
      title: 'Supply only',
      text: 'Want to give it a go yourself? We can supply window privacy film for you to apply yourself.',
      bullets: [
        'On the roll or cut to size',
        'Plain or with cut-outs',
        'Instructions provided',
      ],
    },
    {
      title: 'Care',
      text: 'Window film is very easy to look after and you can keep it clean with soapy water.',
      bullets: [
        'Wait at least 3 weeks before first clean',
        'Use soapy water on a soft cloth or paper towel',
        'No abrasive products',
        'No ammonia-based products',
        'Extra care around cut-out edges, no squeegee',
      ],
    },
  ],

  cta: {
    title: 'Get your free window film quote.',
    text: 'Tell us about your space and we will recommend the perfect privacy film solution.',
    image: '/home/window-privacy-film/etch-bts.jpg',
  },
};

export default windowPrivacyFilm;
